<template>
	<v-popover class="v-date-picker" trigger="click" @open="()=>$refs.panel.init()" ref="input" keep-active>
		<button slot="trigger" class="selected" :id="id" :placeholder="placeholder">
			<span v-if="value">{{Date.format(value,format)}}</span>
		</button>
		<v-date-panel :type="type" :min-date="minDate" :max-date="maxDate" :init-date="initDate" :format="format" :placeholder="placeholder" v-model="model" @close="()=>$refs.input.close()" ref="panel"/>
	</v-popover>
</template>

<script>
export default {
  props: {
    value: {
      default: ""
    },
    id: {
      default: null
    },
    type: {
      default: "text",
      validator(value) {
        return ["text", "timestamp"].includes(value);
      }
    },
    minDate: {
      default: -Infinity
    },
    maxDate: {
      default: Infinity
    },
    initDate: {
      default: null
    },
    format: {
      default: "yyyy-MM-dd"
    },
    placeholder: {
      default: "请选择日期"
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
        if (value != this.value) {
          this.$emit("change", value);
        }
      }
    }
  }
};
</script>

<style lang="less">
.v-date-picker {
  width: 264px;
  display: inline-flex;
  flex-direction: column;
  &.active {
    > .selected {
      border-color: #3e946a;
    }
  }
  > .selected {
    flex: 1;
    outline: none;
    cursor: pointer;
    font-size: 14px;
    padding: 2px 6px;
    min-height: 32px;
    text-align: left;
    user-select: none;
    line-height: 24px;
    position: relative;
    border: 1px solid #cccccc;
    background-color: #ffffff;
    transition: border 300ms;
    &:hover,
    &:focus {
      border-color: #3e946a;
    }
  }
}
</style>